import { render, staticRenderFns } from "./referBonusDetail.vue?vue&type=template&id=b2fcc89c&scoped=true&"
import script from "./referBonusDetail.vue?vue&type=script&lang=js&"
export * from "./referBonusDetail.vue?vue&type=script&lang=js&"
import style0 from "./referBonusDetail.vue?vue&type=style&index=0&id=b2fcc89c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fcc89c",
  null
  
)

export default component.exports